import { Reveal } from "@/components/common/Reveal";

export const SectionHeading = ({ eyebrow, title, intro, align = "left", id }) => (
  <Reveal className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""}`}>
    {eyebrow && <p className="eyebrow mb-5">{eyebrow}</p>}
    <h2 id={id} className="text-4xl sm:text-5xl font-semibold tracking-tight leading-[1.05]">
      {title}
    </h2>
    {intro && <p className="mt-5 text-base sm:text-lg leading-relaxed text-ink-soft">{intro}</p>}
  </Reveal>
);
